<template>
  <div class="">
    <b-field v-bind:label="label">
        <b-taginput
            v-model="selectedModel"
            v-bind:data="filteredData" 
            v-bind:size="size"
            v-bind:placeholder="placeholder"
            v-bind:field = "field" 
            v-bind:maxtags = "maxtags"
            v-bind:allowNew = "allowNew"
            v-bind:openOnFocus = "openOnFocus"
            v-bind:type="type"
            @typing="typingFilterFunc"
            @input="sendChangeEvent"
            autocomplete
            v-bind:style="'max-width:' + maxwidth + 'px'"
            >
        </b-taginput>  
        <!-- <pre>{{allData}}</pre>   -->
        <!-- <pre>{{selectedModel}}</pre>
        <pre>{{existingTags}}</pre>
        <pre>{{newTags}}</pre>             -->
    </b-field>
    <!-- <pre>newTags: {{newTags}}</pre> -->
    <!-- <pre>approvedTags: {{approvedData}}</pre> -->
   <!-- <pre>{{selectedModel}}</pre> -->
  </div>
</template>

<script>
export default {
  name: 'CustomTagInput',
  props: ["label", "placeholder", "size", "maxtags", "allData", "approvedData", "field", "addfunc", "allowNew", "openOnFocus", "autocomplete", "maxwidth", "type"],
  // addData includes cookied routes and rider tags that may or may not have been approved yet. ApprovedData includes only the real data that's been approved.
  data () {
    return {
        filteredData: [],
        selectedModel: [],
        newTags:[],
        existingTags:[]
    }
  },
  watch: {
      selectedModel: function() {
          if (this.allowNew) {
              this.findNewTags();
          }
          
      }
  
  },
    computed: {
        // computedExistingTags: function() {
        //     this.existingTags = [];
        //     this.newTags = [];
        //     var that = this;
        //     this.selectedModel.forEach(function(val, idx) {
        //         var tagname = "";
        //         if (that.field == "" || that.field === undefined) {
        //             tagname = val;
        //         } else {
        //             tagname = val[that.field];
        //         }
        //         // console.log(tagname);
        //         if (!that.allData.includes(tagname)) {
        //             that.newTags.push(tagname);
        //         } else {
        //             that.existingTags.push(tagname);
        //         }
        //     });
        //     console.log("Computed existing tags");
        //     console.log(that.existingTags);
        //     return that.existingTags;
        // },
        // computedNewTags: function() {
        //     this.newTags = [];
        //     this.existingTags = [];
        //     var that = this;
        //     this.selectedModel.forEach(function(val, idx) {
        //         var tagname = "";
        //         if (that.field == "" || that.field === undefined) {
        //             tagname = val;
        //         } else {
        //             tagname = val[that.field];
        //         }
        //         console.log(tagname);
        //         if (!that.allData.includes(tagname)) {
        //             that.newTags.push(tagname);
        //         } else {
        //             that.existingTags.push(tagname);
        //         }
        //     });
        //     console.log("Computed new tags");
        //     console.log(that.newTags);
        //     return that.newTags;
        // }
    },
  methods: {
    // typingFilterFunc() {
    //     return "";
    // },
    arraysEqual(a1,a2) {
        /* WARNING: arrays must not contain {objects} or behavior may be undefined */
        return JSON.stringify(a1)==JSON.stringify(a2);
    },
    typingFilterFunc(text) {
        var data = this.allData;
        var that = this;
        this.filteredData = data.filter((option) => {
            // return option.user.first_name
            if (that.field === undefined) {
                return option
                .toString()
                .toLowerCase()
                .indexOf(text.toLowerCase()) >= 0
            } else {
            return option[that.field]
                .toString()
                .toLowerCase()
                .indexOf(text.toLowerCase()) >= 0
            }
        })
    },
    sendChangeEvent() {
        console.log("CustomTagInput change event");
        if (this.allowNew) {
            this.findNewTags();
        }
        

        this.$emit('changed');
        // console.log("Country added");
    },
    setModel(arr) {
        // console.log("Setting model programatically");
        this.selectedModel = arr;
        this.sendChangeEvent();
    },
    findNewTags() { // tags that aren't in allData
        this.newTags = [];
        this.existingTags = [];
        // console.log("Looking for new tags");
        var that = this;
        this.selectedModel.forEach(function(val, idx) {
            var tagname = "";
            if (that.field == "" || that.field === undefined) {
                tagname = val;
            } else {
                tagname = val[that.field];
            }
            // console.log(tagname);
            // if tag isn't in taginput data list (it's neither approved or cookied), or tag is in data list but NOT in approved list (so it was cookied)
            if (!that.allData.includes(tagname) || (that.allData.includes(tagname) && !that.approvedData.includes(tagname))) {
                that.newTags.push(tagname);
            } else {
                that.existingTags.push(tagname);
            }
        });
        // console.log(that.newTags);
        // console.log("found existing tags:");
        // console.log(this.existingTags);
    }
   
  },
  mounted() {
      this.filteredData = this.allData;
      this.findNewTags();
    //   this.selectedModel = [];
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.taginput .taginput-container > .tag, .taginput .taginput-container > .tags {
    white-space: normal;
    height: auto;
    min-height: 1.7em;
    padding: 7px 10px;
}
.is-small.delete, .is-small.modal-close {
    height: 20px;
    max-height: 20px;
    max-width: 20px;
    min-height: 20px;
    min-width: 20px;
    width: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/CustomTagInput.vue